import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { dateFormatter } from '@/shared/utils/date';
import { format } from 'date-fns';
import { activityLogTableColumns } from '../../constants';
import { AllocationOperationsWorkflowTransitionHistoryDto } from '../../types';

interface MobileTableProps {
  activityLogTableData: AllocationOperationsWorkflowTransitionHistoryDto[];
}

const MobileTable = ({ activityLogTableData }: MobileTableProps) => {
  const TableRow = ({ el }: { el: AllocationOperationsWorkflowTransitionHistoryDto }) => {
    return (
      <MobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{activityLogTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue>{el?.createdAt && dateFormatter(format(new Date(el.createdAt), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{activityLogTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>{el?.operationsWorkflowTransitionTask?.name ?? ''}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{activityLogTableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>
            {el?.user ? `${el.user.firstName} ${el.user.lastName}` : el?.platformManagerTenantName ? el.platformManagerTenantName : '--'}
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {activityLogTableData.length ? (
        activityLogTableData.map((el) => {
          return <TableRow el={el} key={el.id} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;
